import { useEffect, useRef, useState } from "react";
import { Card, Row, FormGroup, Col, Button } from "react-bootstrap";
import { getNoticeList, deleteNotice, getNoticeList_Local, getNoticeRecipientsList } from "../store/api/CommonAPI";
import DatePicker from "react-datepicker2";
import BihamtaTable from "../../Components/BihamtaTable";
import { useDispatch, useSelector } from "react-redux";
import { Link45deg, List, Search } from "react-bootstrap-icons";
import { useForm } from "react-hook-form";
import { downloadFile, setDialog } from "../../store/api/CommonFunctions";
import ModalStringList from "../../Components/Modals/ModalStringList";

const NoticeBoard = () => {
    const dispatch = useDispatch();
    const { handleSubmit } = useForm();
    const filterData = useRef({ Take: 10, Skip: 0 });
    const dateFilters = useRef({});
    const inputDateFrom = useRef();
    const inputDateTo = useRef();
    const [popStringList, setPopStringList] = useState({ show: false });
    const noticeList = useSelector(state => state.CommonReducer.noticeList?.Data ?? []);
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", justInMobile: true },
        { colTitle: "شماره اطلاعیه", colName: "ID", justInMobile: true },
        { colTitle: "تاریخ اطلاعیه", colName: "PNoticeDate", justInMobile: true },
        { colTitle: "دسته بندی اطلاعیه", colName: "PNoticeCategory", justInMobile: true },
        { colTitle: "موضوع اطلاعیه", colName: "NoticeSubject", justInMobile: true },
        { colTitle: "شرح اطلاعیه", colName: "NoticeDesc", justInMobile: false, colType: "string", maxTextLength: 128, hasTooltip:true },
        {colTitle:"ثبت کننده", colName:"CreateByName"}
        // { colTitle: "خوانده شده", colName: "IsRead", justInMobile: false, colType: "boolean" }
    ]
    const tableRowButtons = [
        {
            title:"فهرست دریافت کنندگان",type:"common", tooltip:"فهرست دریافت کنندگان", className:"group-Btn-smalll btn-info",
            icon:<List size={20} color="#00806b"/>,
            onclick: (item)=> showModalStringList(item)
        },
        {
            title:"فایل پیوست",type:"common", className: "group-Btn-smalll btn-secondary",
            icon :<Link45deg className="rowBtn" size={20} color="blue"/>,tooltip:"فایل پیوست(برای باز شدن در تب جدید کلید ctrl را نگه دارید)",
            onclick: (item) => downloadFile(item.ID, "Notice", item?.e?.ctrlKey),
            showCondition: (item)=> Number(item.AttachmentID) > 0
        },                
        {
            title: "حذف اطلاعیه", type: "delete", className: "group-Btn-smalll btn-primary",
            onclick: (item) => {
                const onSuccess = (res) => {
                    if (res === "Success") {
                        const removed = noticeList.filter(n => n.ID !== item.ID);
                        dispatch(getNoticeList_Local({ Data: removed }));
                    }
                }
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف فاکتور',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deleteNotice(item.ID, onSuccess)
                }))

            }
        }
    ]
        ;
    function search() {
        filterData.current.Take = 10;
        filterData.current.Skip = 0;
        filterData.current.DateFrom = inputDateFrom.current.input.value === "" ? null : dateFilters.current.DateFrom;
        filterData.current.DateTo = inputDateTo.current.input.value === "" ? null : dateFilters.current.DateTo;

        dispatch(getNoticeList(filterData.current));
    }
    function showModalStringList(row) {
        const onSuccess = (res) => {
            if (res === "PENDING") {

            }
            else if (res.Data) {
                setPopStringList({
                    show: true,
                    stringList: res.Data,
                    size:"sm",
                    title: "فهرست دریافت کنندگان"
                })
            }
        }
        getNoticeRecipientsList(row.ID, onSuccess);
    }
    useEffect(() => {
        document.body.className = "notMain";
    }, [])
    return (
        <div className="container-fluid mt-3">
            <Card style={{ textAlign: "right" }}>
                <Card.Header className="headerStyle">اطلاعیه های صادر شده</Card.Header>
                <Card.Body className="bodyStyle">
                    <ModalStringList popData={popStringList} setPopData={setPopStringList} />
                    <form onSubmit={handleSubmit(search)}>
                        <Row className="rowBorder">
                            <FormGroup className="col-md-2">
                                <label>از تاریخ: </label>
                                <DatePicker ref={inputDateFrom} popperPlacement="top-start" isGregorian={false} timePicker={false} className="form-control"
                                    onChange={value => dateFilters.current.DateFrom = value.local("en").format("YYYY-MM-DD")} />
                            </FormGroup>
                            <FormGroup className="col-md-2">
                                <label>تا تاریخ: </label>
                                <DatePicker ref={inputDateTo} popperPlacement="top-start" isGregorian={false} timePicker={false} className="form-control"
                                    onChange={value => dateFilters.current.DateTo = value.local("en").format("YYYY-MM-DD")} />
                            </FormGroup>
                            <Col md={2} style={{ display: "flex", flexWrap: "wrap", alignContent: "flex-end", paddingBottom: "3px" }}>
                                <Button className="group-Btn" variant="secondary" type="submit"><Search size={16} />&nbsp; جستجوی اطلاعیه</Button>
                            </Col>
                        </Row>
                    </form>
                    <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} filterData={filterData.current}
                        searchMethod={(data) => dispatch(getNoticeList(data))} reducerName="CommonReducer" objectName="noticeList" hasPaging={true} />
                </Card.Body>
            </Card>
        </div>
    )
}
export default NoticeBoard;